import { FC, PropsWithChildren } from 'react';
import { TipAlign, TipPlacement, Toggletip } from 'ui/tooltip';
import { TooltipContent } from 'ui/tooltip/Tooltip.styled';

export type Props = {
  tooltipContent: string;
  isTooltipEnabled: boolean;
};

// https://aurora.iterable.com/latest/patterns/character-limits-i4kdYHmT#section-animation-properties-87
const animationDuration = 120;

export const CharacterCountTooltip: FC<PropsWithChildren<Props>> = ({
  children,
  tooltipContent,
  isTooltipEnabled = false,
}) => {
  return (
    <Toggletip
      isEnabled={isTooltipEnabled}
      tooltipContent={tooltipContent}
      placement={TipPlacement.Bottom}
      align={TipAlign.End}
      ContentComponent={() => (
        <TooltipContent
          $animationDuration={animationDuration}
          sideOffset={4}
          align={TipAlign.End}
          avoidCollisions
          side={TipPlacement.Bottom}
          arrowPadding={4}
          alignOffset={0}
        >
          {tooltipContent}
        </TooltipContent>
      )}
    >
      {children}
    </Toggletip>
  );
};
